import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api') + '/subscription';

export const initiatePayment = createAsyncThunk('subscription/initiatePayment', async (data) => {
  const r = await axios.post(`${API}/initiate-payment`, data);
  return r.data;
});

export const getAllSubscriptions = createAsyncThunk('subscription/getAll', async () => {
  const r = await axios.get(`${API}/admin/all`);
  return r.data;
});

export const updateSubscriptionStatus = createAsyncThunk('subscription/updateStatus', async ({ subId, status, endDate }) => {
  const r = await axios.patch(`${API}/admin/${subId}`, { status, endDate });
  return r.data;
});

export const runAutoChecks = createAsyncThunk('subscription/runChecks', async () => {
  const r = await axios.post(`${API}/admin/run-checks`);
  return r.data;
});

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    subscriptions: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllSubscriptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.subscriptions = action.payload.subscriptions;
      })
      .addCase(getAllSubscriptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default subscriptionSlice.reducer;
